import { AppContainer } from 'containers';
import { PublicLayout } from 'layouts';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { store } from 'reducers';

const App = () => {
  return (
    <ReduxProvider store={store}>
      <AppContainer>
        <BrowserRouter>
          <Routes>
            <Route path='/*' element={<PublicLayout />} />
          </Routes>
        </BrowserRouter>
      </AppContainer>
    </ReduxProvider>
  );
};

export default App;
